import watchFetchNotificationsSaga from './fetchNotifications';
import watchNotificationShownSaga from './notificationSagas';

const settingSagas = [watchFetchNotificationsSaga(), watchNotificationShownSaga()];
export default settingSagas;
